var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 12,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00B0A0",
    d: "m5.434 11.764-5.2-5.23a.808.808 0 0 1 0-1.137l1.132-1.138a.797.797 0 0 1 1.131 0L6 7.782 13.503.236a.797.797 0 0 1 1.131 0l1.132 1.138a.808.808 0 0 1 0 1.137l-9.2 9.253a.797.797 0 0 1-1.132 0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGreen);
export default __webpack_public_path__ + "static/media/checkGreen.e64998ae0755cc92377f1a871eb7652a.svg";
export { ForwardRef as ReactComponent };